import Vue from "vue";
import Vuex from "vuex";
import VueResource from "vue-resource";
import VuexPersistence from "vuex-persist";
import Cookies from "js-cookie";

import user from "@/store/_user";
import layout from "@/store/_layout";
import log from "@/store/_log";
import VuexSharedMutations from "vuex-shared-mutations";

Vue.use(VueResource);
Vue.use(Vuex);

const storageKey = "ghmGraaHz9";
const storageAuthKey = "n3KdQWxV48p";

// const cookieStorage = new VuexPersistence({
//   key: storageKey,
//   restoreState: (key, storage) => Cookies.getJSON(key),
//   saveState: (key, state, storage) =>
//     Cookies.set(key, state, {
//       expires: 3
//     }),
//   reducer: state => ({
//     user: {
//       // account: state.user.account,
//       account_profile: state.user.account_profile,
//       // account_authority: state.user.account_authority,
//       username: state.user.username,
//       loginId: state.user.loginId,
//       accountId: state.user.accountId,
//       sessionToken: state.user.sessionToken,
//       accessRoles: state.user.accessRoles,
//       authorityRole: state.user.authorityRole,
//       accountType: state.user.accountType,
//       securityTag: state.user.securityTag,
//       securityDisabled: state.user.securityDisabled,
//       attachmentPath: state.user.attachmentPath,
//       daily_statement: state.user.daily_statement,
//       win_lose: state.user.win_lose,
//       daily_summary_company: state.user.daily_summary_company,
//       daily_summary_member: state.user.daily_summary_member,
//       report_statement: state.user.report_statement,
//       // game_result: state.user.game_result,
//       game_result_slots: state.user.game_result_slots,
//       game_result_livecasino: state.user.game_result_livecasino,
//       game_result_sportsbook: state.user.game_result_sportsbook,
//       bonus_list: state.user.bonus_list,
//       adjustment_list: state.user.adjustment_list,
//       alertOn: state.user.alertOn,
//       referee_list: state.user.referee_list,
//       ticket_wallet_trans_list: state.user.ticket_wallet_trans_list,
//       member_details: state.user.member_details,
//       daily_statement_aff: state.user.daily_statement_aff,
//       adjustment_list_aff: state.user.adjustment_list_aff,
//       daily_summary_company_detail: state.user.daily_summary_company_detail,
//       selectedMemberID: state.user.selectedMemberID,
//       selectedOperatorID: state.user.selectedOperatorID,
//       selectedAffiliateID: state.user.selectedAffiliateID,
//       selectedSiteID: state.user.selectedSiteID,
//       selectedTheme: state.user.selectedTheme,
//       isShown: state.user.isShown
//     }
//   })
// });

// const cookieStorage1 = new VuexPersistence({
//   key: storageAuthKey,
//   restoreState: (key, storage) => Cookies.getJSON(key),
//   saveState: (key, state, storage) =>
//     Cookies.set(key, state, {
//       expires: 3
//     }),
//   reducer: state => ({
//     user: {
//       account_authority: state.user.account_authority
//     }
//   })
// });

const localStorage = new VuexPersistence({
  key: storageKey,
  storage: window.localStorage,
  reducer: state => ({
    layout: {
      language: state.layout.language,
      sidebar: state.layout.sidebar,
      pageSize: state.layout.pageSize,
      pageSizeMember: state.layout.pageSizeMember,
      pageSizeCms: state.layout.pageSizeCms,
      pageSizeCampaign: state.layout.pageSizeCampaign,
      pageSizeRescueFund: state.layout.pageSizeRescueFund,
      pageSizeMemberLabel: state.layout.pageSizeMemberLabel,
      pageSizePromo: state.layout.pageSizePromo,
      pageSizeTicket: state.layout.pageSizeTicket,
      pageSizeBankMember: state.layout.pageSizeBankMember,
      pageSizeBank: state.layout.pageSizeBank,
      pageSizeGameNameExclude: state.layout.pageSizeGameNameExclude,
      pageSizeGameResult: state.layout.pageSizeGameResult,
      mbLabelPageSize: state.layout.mbLabelPageSize,
      pageSizeAds: state.layout.pageSizeAds,
      pageSizeCpiMemberList: state.layout.pageSizeCpiMemberList,
      pageSizeCpiCustomList: state.layout.pageSizeCpiCustomList,
      pageSizeCpiOperatorPhoneList: state.layout.pageSizeCpiOperatorPhoneList,
      pageSizeLeaderboard: state.layout.pageSizeLeaderboard,
      pageSizeMission: state.layout.pageSizeMission,
      pageSizeCpiOnCall: state.layout.pageSizeCpiOnCall,
      pageSizeRewardRain: state.layout.pageSizeRewardRain
    },
    user: {
      // account: state.user.account,
      account_profile: state.user.account_profile,
      account_authority: state.user.account_authority,
      username: state.user.username,
      loginId: state.user.loginId,
      accountId: state.user.accountId,
      sessionToken: state.user.sessionToken,
      accessRoles: state.user.accessRoles,
      authorityRole: state.user.authorityRole,
      accountType: state.user.accountType,
      securityTag: state.user.securityTag,
      securityDisabled: state.user.securityDisabled,
      attachmentPath: state.user.attachmentPath,
      daily_statement: state.user.daily_statement,
      win_lose: state.user.win_lose,
      daily_summary_company: state.user.daily_summary_company,
      daily_summary_member: state.user.daily_summary_member,
      report_statement: state.user.report_statement,
      // game_result: state.user.game_result,
      game_result_slots: state.user.game_result_slots,
      game_result_livecasino: state.user.game_result_livecasino,
      game_result_sportsbook: state.user.game_result_sportsbook,
      game_result_cockfight: state.user.game_result_cockfight,
      game_result_rescue: state.user.game_result_rescue,
      game_result_reward: state.user.game_result_reward,
      game_result_free_slots: state.user.game_result_free_slots,
      game_result_others: state.user.game_result_others,
      rebate_member: state.user.rebate_member,
      member_linkage: state.user.member_linkage,
      bonus_list: state.user.bonus_list,
      adjustment_list: state.user.adjustment_list,
      alertOn: state.user.alertOn,
      referee_list: state.user.referee_list,
      ticket_wallet_trans_list: state.user.ticket_wallet_trans_list,
      member_details: state.user.member_details,
      daily_statement_aff: state.user.daily_statement_aff,
      adjustment_list_aff: state.user.adjustment_list_aff,
      daily_summary_company_detail: state.user.daily_summary_company_detail,
      selectedMemberID: state.user.selectedMemberID,
      selectedOperatorID: state.user.selectedOperatorID,
      selectedAffiliateID: state.user.selectedAffiliateID,
      selectedSiteID: state.user.selectedSiteID,
      selectedTheme: state.user.selectedTheme,
      isShown: state.user.isShown,
      tacExpiry: state.user.tacExpiry,
      selectedNewWebsite: state.user.selectedNewWebsite,
      currencyCode: state.user.currencyCode,
      cpiDetails: state.user.cpiDetails,
      authOriginalChecked: state.user.authOriginalChecked
    }
  })
});

// const sessionStorage = new VuexPersistence({
//   key: storageKey,
//   storage: window.sessionStorage,
//   reducer: state => ({
//     user: {
//       username: state.user.username,
//       sessionToken: state.user.sessionToken,
//       accessRoles: state.user.accessRoles
//     }
//   })
// });

const store = new Vuex.Store({
  modules: {
    user,
    layout,
    log
  },
  getters: {
    isShown: state => {
      return state.user.isShown;
    },
    language: state => {
      return state.layout.language;
    },
    pageSize: state => {
      return state.layout.pageSize;
    },
    pageSizeMember: state => {
      return state.layout.pageSizeMember;
    },
    pageSizeCms: state => {
      return state.layout.pageSizeCms;
    },
    pageSizeCampaign: state => {
      return state.layout.pageSizeCampaign;
    },
    pageSizeRescueFund: state => {
      return state.layout.pageSizeRescueFund;
    },
    pageSizeMemberLabel: state => {
      return state.layout.pageSizeMemberLabel;
    },
    pageSizePromo: state => {
      return state.layout.pageSizePromo;
    },
    pageSizeTicket: state => {
      return state.layout.pageSizeTicket;
    },
    pageSizeGameResult: state => {
      return state.layout.pageSizeGameResult;
    },
    pageSizeOptions: state => {
      return state.layout.pageSizeOptions;
    },
    utmPageSize: state => {
      return state.layout.utmPageSize;
    },
    utmPageSizeOptions: state => {
      return state.layout.utmPageSizeOptions;
    },
    mbLabelPageSize: state => {
      return state.layout.mbLabelPageSize;
    },
    mbLabelPageSizeOptions: state => {
      return state.layout.mbLabelPageSizeOptions;
    },
    pageSizeMemberReport: state => {
      return state.layout.pageSizeMemberReport;
    },
    pageSizeMemberLog: state => {
      return state.layout.pageSizeMemberLog;
    },
    pageSizeBankMember: state => {
      return state.layout.pageSizeBankMember;
    },
    pageSizeBank: state => {
      return state.layout.pageSizeBank;
    },
    pageSizeGameNameExclude: state => {
      return state.layout.pageSizeGameNameExclude;
    },
    pageSizeAds: state => {
      return state.layout.pageSizeAds;
    },
    pageSizeCpiMemberList: state => {
      return state.layout.pageSizeCpiMemberList
    },
    pageSizeCpiCustomList: state => {
      return state.layout.pageSizeCpiCustomList
    },
    pageSizeCpiOperatorPhoneList: state => {
      return state.layout.pageSizeCpiOperatorPhoneList
    },
    pageSizeLeaderboard: state => {
      return state.layout.pageSizeLeaderboard
    },
    pageSizeMission: state => {
      return state.layout.pageSizeMission
    },
    pageSizeCpiOnCall: state => {
      return state.layout.pageSizeCpiOnCall
    },
    pageSizeRewardRain: state => {
      return state.layout.pageSizeRewardRain
    },
    username: state => {
      return state.user.username;
    },
    displayName: state => {
      return state.user.username.replace(/\w\S*/g, function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
      // return state.user.username;
    },
    accessRoles: state => {
      return state.user.account_authority;
    },
    accessOptions: state => {
      return state.layout.accessList;
    },
    authorityRole: state => {
      return state.user.authorityRole;
    },
    sessionToken: state => {
      return state.user.sessionToken;
    },
    account: state => {
      return state.user.account;
    },
    loginId: state => {
      return state.user.loginId;
    },
    accountId: state => {
      return state.user.accountId;
    },
    accountProfile: state => {
      return state.user.account_profile;
    },
    accountAuthority: state => {
      return state.user.account_authority;
    },
    accountType: state => {
      return state.user.accountType;
    },
    securityTag: state => {
      return state.user.securityTag;
    },
    securityDisabled: state => {
      return state.user.securityDisabled;
    },
    isLoggedIn: state => {
      if (state.user.sessionToken) {
        return true;
      } else {
        return false;
      }
    },
    isMinimized: state => {
      return state.layout.sidebar.minimized;
    },
    attachmentPath: state => {
      return state.user.attachmentPath;
    },
    dailyStatement: state => {
      return state.user.daily_statement;
    },
    winLose: state => {
      return state.user.win_lose;
    },
    winLoseMember: state => {
      return state.user.win_lose_member;
    },
    dailySummaryCompany: state => {
      return state.user.daily_summary_company;
    },
    dailySummaryOperator: state => {
      return state.user.daily_summary_operator;
    },
    dailySummaryMember: state => {
      return state.user.daily_summary_member;
    },
    reportStatement: state => {
      return state.user.report_statement;
    },
    gameResult: state => {
      return state.user.game_result;
    },
    gameResultSlots: state => {
      return state.user.game_result_slots;
    },
    gameResultLivecasino: state => {
      return state.user.game_result_livecasino;
    },
    gameResultSportsbook: state => {
      return state.user.game_result_sportsbook;
    },
    gameResultCockfight: state => {
      return state.user.game_result_cockfight;
    },
    gameResultRescue: state => {
      return state.user.game_result_rescue;
    },
    gameResultReward: state => {
      return state.user.game_result_reward;
    },
    gameResultFreeSlots: state => {
      return state.user.game_result_free_slots;
    },
    gameResultOthers: state => {
      return state.user.game_result_others;
    },
    rebateMember: state => {
      return state.user.rebate_member;
    },
    memberLinkage: state => {
      return state.user.member_linkage;
    },
    bonusList: state => {
      return state.user.bonus_list;
    },
    adjustmentLog: state => {
      return state.user.adjustment_log;
    },
    bonusLog: state => {
      return state.user.bonus_log;
    },
    loginLog: state => {
      return state.user.login_log;
    },
    resultChangesLog: state => {
      return state.user.result_changes_log;
    },
    vipLog: state => {
      return state.user.vip_log;
    },
    tokenLog: state => {
      return state.user.token_log;
    },
    adjustFreeBalanceLog: state => {
      return state.user.adjust_free_balance_log;
    },
    memberWalletVoucherLog: state => {
      return state.user.member_wallet_voucher_log;
    },
    memberVoucherRedeemedLog: state => {
      return state.user.member_voucher_redeemed_log;
    },
    memberLog: state => {
      return state.user.member_log;
    },
    freespinLog: state => {
      return state.user.freespin_log;
    },
    adjustmentList: state => {
      return state.user.adjustment_list;
    },
    alertOn: state => {
      return state.user.alertOn;
    },
    refereeList: state => {
      return state.user.referee_list;
    },
    winLoseAff: state => {
      return state.user.win_lose_aff;
    },
    ticketWalletTransList: state => {
      return state.user.ticket_wallet_trans_list;
    },
    memberDetails: state => {
      return state.user.member_details;
    },
    pendingTicket: state => {
      return state.user.pending_ticket;
    },
    dailyWinLoseSBDetail: state => {
      return state.user.daily_winlose_sb_detail;
    },
    dailyStatementAff: state => {
      return state.user.daily_statement_aff;
    },
    adjustmentListAff: state => {
      return state.user.adjustment_list_aff;
    },
    dailySummaryCompanyDetail: state => {
      return state.user.daily_summary_company_detail;
    },
    selectedMemberID: state => {
      return state.user.selectedMemberID;
    },
    selectedOperatorID: state => {
      return state.user.selectedOperatorID;
    },
    selectedAffiliateID: state => {
      return state.user.selectedAffiliateID;
    },
    selectedSiteID: state => {
      return state.user.selectedSiteID;
    },
    selectedTheme: state => {
      return state.user.selectedTheme;
    },
    tacExpiry: state => {
      return state.user.tacExpiry;
    },
    selectedNewWebsite: state => {
      return state.user.selectedNewWebsite
    },
    currencyCode: state => {
      return state.user.currencyCode
    },
    cpiDetails: state => {
      return state.user.cpiDetails
    },
    authOriginalChecked: state => {
      return state.user.authOriginalChecked
    }
  },
  plugins: [
    localStorage.plugin,
    // cookieStorage.plugin,
    // cookieStorage1.plugin,
    VuexSharedMutations({
      predicate: [
        "user/updateGuide",
      ]
    })
  ]
});

export default store;
